import appointments from "~/store/appointments";

export function useAppointmentsStore() {
  return appointments;
}
